import React from "react";
import { Typography } from "antd";
const { Text } = Typography;

const IdOrPassport = (props) => {
  const { record } = props;
  return (
    <Text>
      {record["foreign.passport_number"]
        ? record["foreign.passport_number"]
        : record.local_id_number}
    </Text>
  );
};

export default IdOrPassport;
